<ws-modal-wrapper [headerLabel]="modalTitle"
                  (save)="save()"
                  (cancel)="cancel()"
                  [useAceStyles]="true">
    <label>Name</label>
    @if (report.variantName) {
        <div class="d-flex">
            <span class="pe-2 text-nowrap">{{ report.reportName }} -</span>
            <input type="text"
                   [(ngModel)]="report.variantName"
                   maxlength="100"
                   class="form-control form-inline">
        </div>
    }
</ws-modal-wrapper>
